import React, { useEffect } from "react";
import PageNameBanner from "../../components/page-name-banner/PageNameBanner";
import Form from "./components/form/Form";

import './Contact.css'

export default function Contact() {

  return (
    <>
      <PageNameBanner pageName="Contact Us" />
      <div className="contact">
        <div className="contact-form-container">
          <div className="contact-text">
            <p className="connect-text">Connect with One Life</p>
            <h2 className="get-in-touch-text">Get In Touch</h2>
          </div>
          <Form/>
        </div>
      </div>
    </>
  );
}
